function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3007",
  "data-name": "Group 3007",
  transform: "translate(-2 -1.902)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(2 1.902)",
  fill: "rgba(161,164,172,0.2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "insert_drive_file_black_24dp",
  transform: "translate(9.731 8.787)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M0,0H18.327V18.327H0Z",
  transform: "translate(0 0)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M5.527,2a1.525,1.525,0,0,0-1.52,1.527L4,15.745a1.525,1.525,0,0,0,1.52,1.527h9.171a1.532,1.532,0,0,0,1.527-1.527V7.216a1.5,1.5,0,0,0-.451-1.077L12.079,2.451A1.5,1.5,0,0,0,11,2H5.527Zm5.345,4.582V3.145l4.2,4.2H11.636A.766.766,0,0,1,10.873,6.582Z",
  transform: "translate(-0.946 -0.473)",
  fill: "#7ec884"
})));

var SvgApplicationFiles = function SvgApplicationFiles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicationFiles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/application-files.06294007.svg";
export { ForwardRef as ReactComponent };